let rootPath = "/dashboard/";
// const getDate = (value) => {
//     if (value) {
//         const month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
//         let date = new Date(value)
//         let year = date.getFullYear();
//         let mes = month_names_short[date.getMonth()];
//         let dia = date.getDate();
//         value = ("0" + dia).slice(-2) + " " + mes + " " + year;
//         return value;

//     } else {
//         return "N/A"
//     }P
// }

const getDate = (value) => {
  if (value) {
    // const month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let date = new Date(value);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    value = ("0" + day).slice(-2) + "/" + ("0" + month).slice(-2) + "/" + year;
    return value;
  } else {
    return "N/A";
  }
};

const getTomorrow = (value) => {
  if (value) {
    var tomorrow = new Date(new Date(value).getTime() + 24 * 60 * 60 * 1000);
    var dd = String(tomorrow.getDate()).padStart(2, "0");
    var mm = String(tomorrow.getMonth() + 1).padStart(2, "0");
    var yyyy = tomorrow.getFullYear();
    tomorrow = dd + "/" + mm + "/" + yyyy;
    return tomorrow;
  } else {
    return "N/A";
  }
};

const getDateWithoutMonthName = (value) => {
  // (value)
  if (value) {
    let date = new Date(value);
    let year = date.getFullYear();
    let dia = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    // value = dia + "-" + month + "-" + year;
    value = year + "-" + month + "-" + dia;
    return value;
  } else {
    let date = new Date();
    let year = date.getFullYear();
    let dia = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    // value = dia + "-" + month + "-" + year;
    value = year + "-" + month + "-" + dia;
    return value;
  }
};

const get12HoursTime = (value) => {
  // (value && value !== 'N/A')
  if (value) {
    let date = new Date(value);
    let hours = date.getHours();
    var minutes = date.getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes.toString();
    }
    var TimeType;
    if (hours <= 11) {
      TimeType = "AM";
    } else {
      TimeType = "PM";
    }
    value = hours + ":" + minutes + " " + TimeType;
    return value;
  } else {
    return "";
  }
};

// const getToday=()=>{
//     var today = new Date();
//     var dd = String(today.getDate()).padStart(2, '0');
//     var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
//     var yyyy = today.getFullYear();
//     today = yyyy + '-' + mm + '-' + dd;
//     return today;
// }

const getToday = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();
  today = dd + "/" + mm + "/" + yyyy;
  return today;
};

// var day = getTomorrow.getDate()
// var month = getTomorrow.getMonth() + 1
// var year = getTomorrow.getFullYear()

const getDateTime = (value) => {
  if (value && value !== "N/A") {
    let date = new Date(value);
    let year = date.getFullYear();
    let mes = date.getMonth() + 1;
    let dia = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    // value = dia + "/" + mes + "/" + year + " " + hours + ":" + minutes + ":" + seconds;
    var TimeType;
    if (hours <= 11) {
      TimeType = "AM";
    } else {
      TimeType = "PM";
    }
    value =
      dia +
      "-" +
      mes +
      "-" +
      year +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " " +
      TimeType;
    return value;
  } else {
    return "N/A";
  }
};
var toHHMMSS = (secs) => {
  if (secs) {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map((v) => (v < 10 ? "0" + v : v))
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  } else {
    return "--:--";
  }
};
const emailMask = (value) => {
  if (value) {
    let str = value;
    str = str.split("");
    let finalArr = [];
    let postfix = value.substring(str.indexOf("@"));
    var index = str.lastIndexOf("@");
    str = str.splice(0, 9);
    str.forEach((item, pos) => {
      pos >= 1 && pos <= str.length - 2
        ? finalArr.push("*")
        : finalArr.push(str[pos]);
    });

    return finalArr.join("") + postfix;
  } else {
    return value;
  }
};

const getTime = (dateTime) => {
  if (dateTime) {
    return new Date(dateTime).toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  } else {
    return "--:--";
  }
};

// const getTime = (value) => {
//     if (value) {
//         let date = new Date(value)
//         let hours = date.getHours();
//         let minutes = date.getMinutes();
//         let seconds = date.getSeconds();
//         value = hours + ":" + minutes + ":" + seconds;
//         return value;

//         // return new Date(dateTime).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
//     } else {
//         return "--:--"
//     }
// }

const maskMobile = (value) => {
  if (value) {
    let str = value;
    str = str.toString().split("");
    let finalArr = [];
    str.forEach((item, pos) => {
      pos >= 1 && pos <= str.length - 2
        ? finalArr.push("*")
        : finalArr.push(str[pos]);
    });
    return finalArr.join("");
  } else {
    return value;
  }
};
const getSeconds = (h, m, s) => {
  let time = h + ":" + m + ":" + s;
  time = time
    .split(":")
    .reverse()
    .reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
  return time.toString();
};
const concatEfg = (min, max) => {
  return "Min " + min + " - " + "Max " + " " + max;
};
const searchFilter = (string, array) => {
  let temRows = array.map((obj) => {
    return JSON.stringify(obj);
  });
  let filteredRow = temRows.filter((r) => {
    return r.toLowerCase().includes(string.toLowerCase());
  });
  let finalRows = filteredRow.map((obj) => {
    return JSON.parse(obj);
  });
  return finalRows;
};
const handleSort = (property, format, rows, isAsc) => {
  let temp = [];

  if (format && format === "Date" && isAsc) {
    temp = rows.sort(function (a, b) {
      return new Date(b[property]) - new Date(a[property]);
    });
  } else if (format && format === "Date" && !isAsc) {
    temp = rows.sort(function (a, b) {
      return new Date(a[property]) - new Date(b[property]);
    });
  } else if (format && format === "number" && isAsc) {
    temp = rows.sort(function (a, b) {
      if (a[property] === null) {
        return 1;
      } else if (b[property] === null) {
        return -1;
      } else {
        return b[property] - a[property];
      }
    });
  } else if (format && format === "number" && !isAsc) {
    temp = rows.sort(function (a, b) {
      if (a[property] === null) {
        return -1;
      } else if (b[property] === null) {
        return 1;
      } else {
        return a[property] - b[property];
      }
    });
  } else if (format && format === "boolean" && isAsc) {
    temp = rows.sort(function (a, b) {
      if (a[property] === null) {
        return 1;
      } else if (b[property] === null) {
        return -1;
      } else {
        return Number(b[property]) - Number(a[property]);
      }
    });
  } else if (format && format === "boolean" && !isAsc) {
    temp = rows.sort(function (a, b) {
      if (a[property] === null) {
        return -1;
      } else if (b[property] === null) {
        return 1;
      } else {
        return Number(a[property]) - Number(b[property]);
      }
    });
  } else if (isAsc) {
    temp = rows.sort(function (a, b) {
      if (b[property] && a[property]) {
        return a[property].localeCompare(b[property]);
      }
      if (a[property] === null) {
        return 1;
      } else if (b[property] === null) {
        return -1;
      }
    });
  } else {
    temp = rows.sort(function (a, b) {
      if (b[property] && a[property]) {
        return b[property].localeCompare(a[property]);
      }
      if (a[property] === null) {
        return -1;
      } else if (b[property] === null) {
        return 1;
      }
    });
  }

  return temp;
};
module.exports = {
  rootPath: rootPath,
  prospectPath: rootPath + "prospect",
  viewInternalSupportPath: rootPath + "viewinternalsupport",
  addInternalSupportPath: rootPath + "addinternalsupport",
  editInternalSupportPath: rootPath + "editinternalsupport",
  viewMitsReportsPath: rootPath + "viewmitreport",
  viewMitsChildReportsPath: rootPath + "viewmitschildreport",
  viewmissalesreportall: rootPath + "viewmissalesreport",
  viewmissalesreportchild: rootPath + "viewmissalesreportchild",
  createfranchisepath: rootPath + "createfranchise",
  uploadecxel: rootPath + "uploadexcel",
  viewmissalesreportsdetailsPath: rootPath + "view_mis_sales_details",
  viewSalesMisReportsPath: rootPath + "viewsalesmisreports",
  marketingpath: rootPath + "marketing",
  marketingparentpath: rootPath + "marketingparent",
  // viewMitsNestedChildReportsPath: rootPath + "viewmitsnestedchildreport",
  ViewNestedChildMisReportsPath: rootPath + "view_nested_misreports",
  viewSalesReportsPath: rootPath + "viewallcdtreports",
  viewResearchReportsPath: rootPath + "viewresearchreports",
  ViewCdtReportsPath: rootPath + "viewcdtreports",
  ViewCdtParticularPath: rootPath + "viewparticularcdtreport",
  ViewCDTyetToSubscribePath: rootPath + "viewcdtyestosubscribe",
  // otpPath: rootPath + "otp",
  prospectDetailsPath: rootPath + "prospectDetalis",
  communicatioTimeLinePath: rootPath + "communication_timeline",
  investorcommunicationTimeLinePath:
    rootPath + "investor_communication_timeline",

  addCommunicatioTimeLinePath: rootPath + "add_communication_timeline",
  addProspectTaskPath: rootPath + "addTaskProspect",
  investorAddCommunicatioTimeLinePath:
    rootPath + "investor_add_communication_timeline",

  activityLogPath: rootPath + "activity_log",
  investmentProfilePath: rootPath + "investment_profile",
  personalProfilePath: rootPath + "personal_profile",
  prospectSatisfactionPath: rootPath + "prospect_satisfaction",
  addReviewPath: rootPath + "add_review",
  addInvestorReviewPath: rootPath + "add_investor_review",
  investorNotifiCationManagerPath: rootPath + "investor_notifiCation_manager",

  referralDashboardPath: rootPath + "referral_dashboard",
  referralDashboardOverViewPath: rootPath + "referral_dashboard_overview",
  addProspectPath: rootPath + "addprospect",
  editProspectPath: rootPath + "editProspect",
  addTicketPath: rootPath + "addticket",
  editTicketPath: rootPath + "editticket",
  addPaymentPath: rootPath + "addpayment",
  addDiscountPath: rootPath + "addDiscount",
  investmentPath: rootPath + "investmentOverView",
  investmentsPath: rootPath + "investments",
  investmentDetailsPath: rootPath + "investment_detalils",

  editInvestPath: rootPath + "editInvestornew",
  investmentAddPaymentPath: rootPath + "investment_add_payment",
  investmentDiscountPath: rootPath + "investor_discount_request",
  investmentReferalDashboardPath: rootPath + "investor_referal_request",
  investorActivityLogPath: rootPath + "investor_activity_log",
  editInvestmentPath: rootPath + "edit_investment_path",
  investmentPersonalProfilePath: rootPath + "investment_personal_profile",
  investorInvestmentProfilePath: rootPath + "investor_investment_profile",
  investmentSatisfactionPath: rootPath + "investment_satisfaction",
  investmentAdvicePath: rootPath + "investment_advice",
  createNotificationPath: rootPath + "create_notification",
  investorCreateNotificationPath: rootPath + "investor_create_notification",
  createEmailPath: rootPath + "create_email",
  investorCreateEmailPath: rootPath + "investor_create_email",
  executiveListPath: rootPath + "executive_list",
  propectexecutiveListPath: rootPath + "prospect_executive_list",
  alltasks: rootPath + "alltasks",
  invalltasks: rootPath + "invalltasks",
  landingpage2Path: rootPath + "LandingPage2", //mk
  razorpyPath: rootPath + "RazorPy", //mk
  addSubscriptionPath: rootPath + "AddSubscription", //mk
  investmentAddSubscriptionPath: rootPath + "AddInvSubscription", //mk

  vantagePath: rootPath + "Synapse",
  addInvestmentPath: rootPath + "add_investment",
  addVantagePath: rootPath + "addvantage",
  referralManagerPath: rootPath + "referral_manager",
  userManagementPath: rootPath + "user_management",
  addTheme: rootPath + "add_theme",
  addEFG: rootPath + "add_efg",
  editEFG: rootPath + "edit_efg",

  subscriptionManagerPath: rootPath + "subscription_manager",
  subscriptiondetailsPath: rootPath + "subscriptiondetails",
  extendsubscriptionPath: rootPath + "extendsubscription",
  lookupManagerPath: rootPath + "lookup_manager",
  addLookupManagerPath: rootPath + "add_lookup_manager",
  contentManagementPath: rootPath + "content_management",
  addContentManagementPath: rootPath + "add_content_management",
  editContentManagementPath: rootPath + "edit_content_management",
  brokerManagerPath: rootPath + "broker_manager",
  prospectcallRequestsPath: rootPath + "prospectcall_requests",
  investorcallRequestsPath: rootPath + "invcall_requests",
  callRequestsTabsPath: rootPath + "callRequests",
  myPerformancePath: rootPath + "my_performance",
  investorPortFolioPath: rootPath + "investor_porfolio",
  editInvestorQuestioner: rootPath + "edit_investor",
  beigeManagementPath: rootPath + "beige_management",
  goalsDashboardPath: rootPath + "goals_dashboard",
  prospectGoalsDashboardPath: rootPath + "prospect_goals_dashboard",
  addDiscountOverAllPath: rootPath + "add_discount_request_overall",
  editUserPath: rootPath + "edit_user",
  investorindividualRequestPath: rootPath + "investor_individual_request",
  addNotificationPath: rootPath + "add_notification",
  gromocodepathPath: rootPath + "gromo_code",
  menuuploadpathPath: rootPath + "upload_excel_mutualfunds",
  franchiseDashboard: rootPath + "franchisedashboard",
  delrequestspath: rootPath + "investment_delete_requests",

  // Re-assign rm comments list view
  reassignRmList: rootPath + "reassignrms",

  // MANUAL ADVICE SECTIONS
  createAdviseRequestPath: rootPath + "createadvicerequests",
  AddAdviseRequestPath: rootPath + "addadvise",
  adviceRequestsPath: rootPath + "adviserequest",
  manualAdviceTabsPath: rootPath + "manualadvices",
  advicesPendingPath: rootPath + "pendingadvices",
  rebalance_sell_path: rootPath + "rebalanceSellBuy",
  rebalance_data_path: rootPath + "rebalance",

  // Notes Review section
  notesReview: rootPath + "notesreview",

  // goals advices stopped
  goalAdvicesStopped: rootPath + "goaladvices",

  // Add Payment Links Card
  addpaymentlinks: rootPath + "addpaymentlinks",

  // Rebalance Advice Page Button Path
  rebalanceAdvicePath: rootPath + "rebalanceadvice",

  // Cheking status tracking
  checkstatutracking: rootPath + "checkstatutracking",

  cdt_create_advice: rootPath + "cdtcreateadvice",
  auapath: rootPath + "aua_proposal",

  // Portfolio Review Tabs Path
  portfolioReviewTabsPath: rootPath + "portfolioReview",

  // Portfolio Review Sent Path
  sentportfolioReviewPath: rootPath + "sentportfolioReview",

  // Portfolio Review Sent Detail View Button Path
  sentdetailviewportfolioReviewPath: rootPath + "sentdetailviewportfolioReview",

  // Portfolio Review Add Button Path
  addportfolioReviewPath: rootPath + "addportfolioReview",

  // Portfolio Review Add Button Path
  pendingportfolioReviewPath: rootPath + "pendingportfolioReview",

  // Portfolio Review Detail View Button Path
  detailviewportfolioReviewPath: rootPath + "detailviewportfolioReview",

  // Onboarding Managar Path
  onboardingoverviewPath: rootPath + "OnboardingManagar",

  getDate: getDate,
  emailMask: emailMask,
  maskMobile: maskMobile,
  toHHMMSS: toHHMMSS,
  getTime: getTime,
  getSeconds: getSeconds,
  getDateTime: getDateTime,
  concatEfg: concatEfg,
  getDateWithoutMonthName: getDateWithoutMonthName,
  searchFilter: searchFilter,
  handleSort: handleSort,
  getToday: getToday,
  getTomorrow: getTomorrow,
  get12HoursTime: get12HoursTime,
};
